import { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";

class FinanceirasProvider extends AProvider {
    constructor() {
        super("/financeiro/financeiras");
    }

    getFinanceirasValidas = async (codigo_venda: string): Promise<number[]> => {
        const request: IDataRequest = {
            url: `/financeiro/financeiras/listar/${codigo_venda}`
        }

        const result = await this.httpClient.get(request);

        if (result.statusCode === STATUS_CODE.OK) {
            return result?.data.financeiras || [];
        }

        return []
    }

    getTermosFinanceiras = async (codigo_venda: string, financeiras: number[]): Promise<IDataResponse> => {
        const request: IDataRequest = {
            url: `/pagamentos/financiamentos_termos_aceite/${codigo_venda}`,
            data: {
                financeiras: financeiras
            }
        }

        return await this.httpClient.post(request);
    }

}
export const financeirasProvider = new FinanceirasProvider();
export { FinanceirasProvider }